import { gql } from '@apollo/client';

export const TEMPLETES_FOR_INVITATION = gql`
  query publisherInvitations($input: PublisherInvitationInput!) {
    publisherInvitations(input: $input) {
      id
      merchantId
      name
      description
      subject
      message
      template
    }
  }
`;
